module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard.03910762.svg";